/**
 * The content cursor, per workspace, held in this tab's memory and nowhere else.
 *
 * Deliberately not the IndexedDB registry: that store is shared by every tab, and a tab that drains a signal late
 * would read a cursor another tab had already moved past the row. Here a cursor only advances when this tab finishes
 * a pass, and a pass consumes every signal queued so far, so no signal this tab still holds can be behind it. A fresh
 * tab has no cursor and fetches signaled items whole once.
 */
const cursors = new Map<string, Date>();

export function getContentCursor(workspaceId: string): Date | undefined {
  return cursors.get(workspaceId);
}

export function setContentCursor(workspaceId: string, cursor: Date): void {
  cursors.set(workspaceId, cursor);
}

export function clearContentCursors(): void {
  cursors.clear();
}
